import {Inject, Injectable} from '@angular/core';
import {select, Store} from "@ngrx/store";
import {CommonsActions} from "./commons.actions";
import {loadingSelector} from "./commons.state";

@Injectable({
  providedIn: 'root',
})
export class CommonsFacadeService {

  constructor(@Inject(Store) private store: Store<any>) {

  }

  selectLoader() {
    return this.store.pipe(select(loadingSelector));
  }

  setLoaderOn() {
    this.store.dispatch(CommonsActions.setLoaderOn());
  }

  setLoaderOff() {
    this.store.dispatch(CommonsActions.setLoaderOff());
  }

}
